// src/features/tasks/components/TaskListPage/TasksDataGrid/components/DateCell.jsx
import React from 'react';
import { Typography } from '@mui/material';
import DateWithHint from '../../../../../../components/common/DateWithHint';

export default function DateCell({ value, label, row }) {
  if (!value) return <Typography variant="body2" color="text.disabled">-</Typography>;

  const date = new Date(value);
  const showOverdue = !(row?.state === 'COMPLETED' || row?.state === 'CANCELLED');

  return (
    <DateWithHint 
      date={date}
      highlightOverdue={showOverdue}
      highlightUpcoming={showOverdue}
    />
  );
}